
export class SelectListItem<T> {
    constructor(public readonly value: T, public readonly label: string) { }
}
